<template>
    <v-card outlined tile class="v-card--default-outlined">
        <v-expansion-panels accordion multiple flat v-model="activePanels">
            <v-expansion-panel>
                <v-expansion-panel-header class="grey-ef">
                    <span class="font-size-16 font-size-md-18 font-weight-medium">검색어</span>
                    <template #actions>
                        <v-icon v-if="activePanels.includes(0)">mdi-minus</v-icon>
                        <v-icon v-else>mdi-plus</v-icon>
                    </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <div>
                        <v-select v-model="searchKey" :items="searchKeys" outlined hide-details dense />
                        <v-text-field v-model="keyword" outlined hide-details dense placeholder="검색어를 입력하세요" @keydown.enter="search" append-icon="mdi-magnify" class="mt-10" @click:append="search" />
                    </div>
                </v-expansion-panel-content>
                <v-divider class="grey-da"></v-divider>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header class="grey-ef">
                    <span class="font-size-16 font-size-md-18 font-weight-medium">경매상태</span>
                    <template #actions>
                        <v-icon v-if="activePanels.includes(1)">mdi-minus</v-icon>
                        <v-icon v-else>mdi-plus</v-icon>
                    </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <div>
                        <v-checkbox v-for="state in auctionStateItems" v-model="auctionStates" :key="state.value" :label="state.text" :value="state.value" multiple hide-details dense />
                    </div>
                </v-expansion-panel-content>
                <v-divider class="grey-da"></v-divider>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header class="grey-ef">
                    <span class="font-size-16 font-size-md-18 font-weight-medium">경매구분</span>
                    <template #actions>
                        <v-icon v-if="activePanels.includes(2)">mdi-minus</v-icon>
                        <v-icon v-else>mdi-plus</v-icon>
                    </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <div>
                        <v-checkbox v-for="state in auctionCategoryItems" v-model="auctionCategories" :key="state.value" :label="state.text" :value="state.value" multiple hide-details dense />
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <v-card-actions>
            <v-btn large block color="primary" @click="search">검색하기</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
const searchKeys = [
    { text: "전체", value: null },
    { text: "LOT", value: "lot" },
    { text: "작품명", value: "subject" },
    { text: "작가명", value: "author" },
];
const auctionStateItems = [
    { text: "종료", value: "hasDone" },
    { text: "진행중", value: "onGoing" },
];
const auctionCategoryItems = [
    { text: "Online Auction", value: "A" },
    { text: "After Sale Online", value: "B" },
    { text: "Private Sales", value: "P" },
];

export default {
    props: {
        totalCount: { type: Number, default: 0 },
    },
    data() {
        return {
            activePanels: [0, 1, 2],

            searchKeys,
            searchKey: this.$route.query.searchKey || null,

            keyword: this.$route.params.keyword || null,

            auctionStateItems,
            auctionStates: this.$route.query.auctionStates ? [this.$route.query.auctionStates].flat() : auctionStateItems.map(({ value }) => value),

            auctionCategoryItems,
            auctionCategories: this.$route.query.auctionCategories ? [this.$route.query.auctionCategories].flat() : auctionCategoryItems.map(({ value }) => value),
        };
    },
    computed: {
        path() {
            if (this.keyword) return `/auction-search/${this.keyword}`;
            else return "/auction-search";
        },
    },
    watch: {
        "$route.query.searchKey"() {
            this.searchKey = this.$route.query.searchKey || null;
        },
        "$route.params.keyword"() {
            this.keyword = this.$route.params.keyword || null;
        },
    },
    methods: {
        search() {
            try {
                let { path, searchKey, auctionStates, auctionCategories } = this;

                if (auctionStates.length < 1) throw new Error("경매상태를 선택하세요.");
                if (auctionStates.length >= auctionStateItems.length) auctionStates = undefined;

                if (auctionCategories.length < 1) throw new Error("경매구분을 선택하세요.");
                if (auctionCategories.length >= auctionCategoryItems.length) auctionCategories = undefined;

                this.$router.push({
                    path,
                    query: {
                        ...(this.keyword && searchKey ? { searchKey } : {}),
                        auctionStates,
                        auctionCategories,
                        page: 1,
                    },
                });
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
    },
};
</script>

<style scoped>
</style>